import React from 'react';

const SvgBh = (props) => (
  <svg width="1em" height="1em" viewBox="0 0 28 20" {...props}>
    <defs>
      <rect id="BH_svg__a" x={0} y={0} width="100%" height="100%" rx={2} />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="BH_svg__b" fill="#fff">
        <use xlinkHref="#BH_svg__a" />
      </mask>
      <rect
        stroke="#F5F5F5"
        strokeWidth={0.5}
        x={0.25}
        y={0.25}
        width={27.5}
        height={19.5}
        rx={2}
      />
      <path
        d="M8 0h20v20H10l-2-1.333 2-1.334L8 16l2-1.333-2-1.334L10 12l-2-1.333 2-1.334L8 8l2-1.333-2-1.334L10 4 8 2.667l2-1.334L8 0z"
        fill="#E7243B"
        mask="url(#BH_svg__b)"
      />
    </g>
  </svg>
);

export default SvgBh;
